import { FC, ReactNode, useEffect, useState } from 'react';
import { Tabs } from '@dynamika-shared/ui/Tabs/Tabs';
import { useLocation } from 'react-router-dom';
import { twMerge } from '@dynamika-shared/utils/twMerge';
import { generateTabsItems, RoutesType } from '@utils/generateTabsItems';
import { usersAndLogsSubRoutes } from '@router/UsersAndLogs.routes';
import { useUsersListSlice } from '@restore/usersList/usersList.slice';
import { useAuthSlice } from '@restore/auth/auth.slice';
import { UserRoles } from '@dynamika-shared/types/auth';

type UsersAndLogsProps = {
  children: ReactNode;
};
export const UsersAndLogs: FC<UsersAndLogsProps> = ({ children }) => {
  const [currentPathname, setCurrentPathname] = useState('');
  const usersCount = useUsersListSlice(state => state.data?.totalElements);
  const userRole = useAuthSlice(s => s.data?.selectedRole);

  const visibleRoutes = usersAndLogsSubRoutes.filter(route => {
    if (!route.allowedRoles) return true;
    return userRole && route.allowedRoles.includes(userRole as UserRoles);
  });

  const tabsItems = generateTabsItems({
    routes: visibleRoutes as RoutesType,
    currentPathname,
    extraText: { Users: usersCount ? String(usersCount) : '' },
  });

  const { pathname } = useLocation();

  useEffect(() => {
    const lastPathPart = pathname.split('/').pop();
    setCurrentPathname(lastPathPart ?? '');
  }, [pathname]);
  return (
    <div>
      <div
        data-testid='ClinicalTrial'
        className={'min-h-[calc(100%-5.6rem)] max-w-full'}
      >
        <header
          className={'mini:py-2 flex w-full items-center justify-between py-4'}
        >
          <h2
            className={
              'mini:text-[2.4rem] text-left text-[3.6rem] font-semibold leading-[4rem] tracking-normal'
            }
          >
            Users & Logs
          </h2>
        </header>
        {currentPathname && (
          <div
            className={twMerge(
              'flex flex-col min-h-[calc(100%-110px)] relative'
            )}
          >
            <Tabs activeKey={currentPathname} items={tabsItems} />
          </div>
        )}
        {children}
      </div>
    </div>
  );
};
